import {useMemo,useEffect,useState} from "react";
import COMPONENT_MAP from '../Repository/Components.js';
import {getSKUBatchSummary} from '../../integration/Api.js'
import {consoleLog} from '../../../core/utilities/Utilities.js';
const file='SKUDetailBatches.js';

const SKUDetailBatches=({parentId,application,userData,parent})=>{
    const [loading,setLoading]=useState(true);
    const [records,setRecords]=useState([]);
    
    const getRecords=(isSubscribed,sku_id)=>{
        getSKUBatchSummary({sku_id:sku_id})
        .then((data)=>{
            consoleLog({file:file,context:'getRecords - getSKUBatchSummary',arg_name:'data',arg_value:data});
            if(isSubscribed){
                if('error' in data){
                }
                else{
                    setRecords(data);
                }
            }
            setLoading(false);
        });
    };

    const handleClickEvent=async(args)=>{
        consoleLog({file:file,context:'handleClickEvent',arg_name:'event',arg_value:args});
        switch(args?.action){
            case "refresh":
                setRecords([]);
                getRecords(true,parentId);
                break;
            default:
                break;
        }
    }

    useEffect(()=>{
        let isSubscribed=true;
        if(parentId){
            getRecords(isSubscribed,parentId);
        }
        else{
            setLoading(false);
        }
        return ()=>(isSubscribed=false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[parentId]);

    const list_name='sku_batches';

    const renderList=useMemo(()=>{
        const Component=COMPONENT_MAP['List'];
        return Component?(
            <Component
                records={records}
                list_name={list_name}
                loading={loading}
                height={'50vh'}
                file={file}
                application={application}
                initialState={{}}
                checkboxSelection={false}
                disableRowSelectionOnClick={true}
                disableSelectionOnClick={true}
                canRemoveSelection={false}
                entityRules={{'entityRules':'false'}}
                userData={userData}
                focusOnSearchInput={true}
                handleClickEvent={handleClickEvent}
                handleSelection={null}
                filterComponent={null}
            />
        ):null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[loading,records])
    
    return(renderList);
}
export default SKUDetailBatches;
